// Mirrors backend validate_password_complexity (server.py). When backend
// rules change, update both sides.
export const passwordComplexityErrors = (pwd) => {
  const errs = [];
  if (!pwd || pwd.length < 12) errs.push('At least 12 characters');
  if (!/[A-Z]/.test(pwd)) errs.push('One uppercase letter');
  if (!/[a-z]/.test(pwd)) errs.push('One lowercase letter');
  if (!/[0-9]/.test(pwd)) errs.push('One digit');
  if (!/[^A-Za-z0-9]/.test(pwd)) errs.push('One special character');
  return errs;
};
